// Guids so the user can't just type "admin" in the localStorage.  If they guess the guid... well.. they deserve it
// const FormCodes = Object.freeze({
//     SuveryEditReport:'14648f8e-0261-45e2-8f02-69d8832d828a',
//     BatchReportSummary: '14648f8e-0261-45e2-8f02-69d8832d828a',
//     BatchReportDetail: '14648f8e-0261-45e2-8f02-69d8832d828a',
//     ClientList: '14648f8e-0261-45e2-8f02-69d8832d828a',
//     SurveyPrintProjections: '14648f8e-0261-45e2-8f02-69d8832d828a',
//     SurveyCount: '14648f8e-0261-45e2-8f02-69d8832d828a',
//     ImportAnalysis: '14648f8e-0261-45e2-8f02-69d8832d828a',
//     ImportAnalysisQuarterly: '14648f8e-0261-45e2-8f02-69d8832d828a',
//     CheckForMissingContracts:'14648f8e-0261-45e2-8f02-69d8832d828a',
//     BatchSummaryByClient:'14648f8e-0261-45e2-8f02-69d8832d828a',
//     SurveysMailedReport:'14648f8e-0261-45e2-8f02-69d8832d828a',
//     SurveysReceivedReport:'14648f8e-0261-45e2-8f02-69d8832d828a',
//     CheckImports : '14648f8e-0261-45e2-8f02-69d8832d828a',
//     ReturnedMailReport:'14648f8e-0261-45e2-8f02-69d8832d828a'

//   });

const FormCodes = Object.freeze({
  CLIENT_REPORTS: '7cf26ae0-e52e-4544-b558-1450e324dc0e',
  SURVEY_REPORTS: '14648f8e-0261-45e2-8f02-69d8832d828a',
  ANALYSIS_FUNERAL: 'a3257cb9-872f-42a0-8463-2a65d6a25590',
  ANALYSIS_CREMATION: 'a024bd65-da27-41d3-9fa2-a8d4a2cc3b1b',
  ANALYSIS_CEMETARY: '5dcdbcdc-049a-4d99-baf0-b2ecc306f998',
  ANALYSIS_MONUMENT: '7ecdac08-8db7-415a-a8a7-6c6b430a6572',
  ANALYSIS_PRENEED: 'a5225fe6-61b2-4162-863e-bc86b226e618',
  ANALYSIS_PET: 'eb51bc2d-eea9-44d5-9d84-012738d7cd12',
  ANALYSIS_EVENT: '6f6ad266-2777-417a-a400-57c1eaa01cde',
  OPPORTUNITY_PLAN: 'aa8003c1-ad06-41bd-b205-8da15dad0175',
  IMPORT: '69d6bf7f-56ed-4408-9856-04a39a0bb4c7',
});

export default FormCodes;

// 7cf26ae0-e52e-4544-b558-1450e324dc0e : Client Reports
/* 14648f8e-0261-45e2-8f02-69d8832d828a : Survey Reports
a3257cb9-872f-42a0-8463-2a65d6a25590 : Analysis Reports - Funeral
a024bd65-da27-41d3-9fa2-a8d4a2cc3b1b : Analysis Reports - Cremation
5dcdbcdc-049a-4d99-baf0-b2ecc306f998 : Analysis Reports - Cemetary
7ecdac08-8db7-415a-a8a7-6c6b430a6572 : Analysis Reports - Monument
a5225fe6-61b2-4162-863e-bc86b226e618 : Analysis Reports - PreNeed
eb51bc2d-eea9-44d5-9d84-012738d7cd12 : Analysis Reports - Pet Cremation
6f6ad266-2777-417a-a400-57c1eaa01cde : Analysis Reports - Event */
